import * as React from 'react'

export const AmplitudeNaked = (props: React.ComponentProps<'svg'>) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" {...props}>
        <path
            fill="#4ee59a"
            d="m62.1,67.02c-2.81,0-5.75,3.66-9.03,11.35-3.84,10.01-8.21,21.4-8.21,21.4,0,0,4.75,14.35,7.42,21.4h0c2.66,7.04,4.19,11.36,10.82,11.36h.03c2.81,0,5.75-3.66,9.03-11.36,3.84-10.01,8.21-21.4,8.21-21.4,0,0-4.75-14.35-7.42-21.4-2.66-7.05-4.2-11.37-10.84-11.35Z"/>
        <path
            fill="#4ee59a"
            d="m118.29,44.86c-9.24,0-13.03,8.9-15.38,13.83-2.34,4.93-22.56,41.08-22.56,41.08h0s18.96,35.41,21.79,41.08h0c2.83,5.68,7.38,13.83,16.62,13.83s13.03-8.9,15.38-13.83c2.34-4.93,22.56-41.08,22.56-41.08h0s-18.96-35.4-21.79-41.08c-2.84-5.68-7.38-13.83-16.62-13.83Z"/>
        <path
            fill="#4ee59a"
            d="m100.44,6.1C48.73,6.1,6.81,48.02,6.81,99.73s41.92,93.63,93.63,93.63,93.63-41.92,93.63-93.63S152.15,6.1,100.44,6.1Zm0,168.88c-41.56,0-75.25-33.69-75.25-75.25h0c0-41.56,33.69-75.25,75.25-75.25s75.25,33.69,75.25,75.25-33.69,75.25-75.25,75.25Z"/>
    </svg>
)
